/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.timesheets.summary'},
});

const SummaryItem = () => (
  <RouteLinkItem
    route="midas/settings/timesheets/timesheets-summary"
    title={messages.title}
  />
);

export default SummaryItem;
